/**
 * Namespaced so we don't pollute the global intellisense namespace with a billion generically named constants
 */
export namespace RuntimeConfigurationServiceDomain {
    export enum NodeEnvironment {
        DEVELOPMENT = 'development',
        PRODUCTION = 'production',
        TEST = 'test',
    }

    export enum DeploymentEnvironment {
        LOCAL = 'local',
        DEVELOPMENT = 'itrc_dev',
        STAGING = 'itrc_stage',
        PRODUCTION = 'itrc_prod',
    }
    /**
     * Provides the union of behaviors between the server and client config providers
     */
    export abstract class RuntimeConfigProvider {
        public abstract get deploymentEnvironment(): RuntimeConfigurationServiceDomain.DeploymentEnvironment;

        public abstract get nodeEnvironment(): RuntimeConfigurationServiceDomain.NodeEnvironment;

        public abstract get isMergeRequest(): boolean;

        /**
         * Returns true if the deployment environment is not production
         */
        public get isLowerEnvironment(): boolean {
            return this.deploymentEnvironment !== RuntimeConfigurationServiceDomain.DeploymentEnvironment.PRODUCTION;
        }

        /**
         * Returns true so long as the deployment environment is not production or staging
         */
        public get isDevelopmentEnvironment(): boolean {
            const DEVELOPMENT_ENVIRONMENTS = [
                RuntimeConfigurationServiceDomain.DeploymentEnvironment.DEVELOPMENT,
                RuntimeConfigurationServiceDomain.DeploymentEnvironment.LOCAL,
            ];
            return DEVELOPMENT_ENVIRONMENTS.includes(this.deploymentEnvironment);
        }
    }

    /**
     * Warning: enum values here are exported to the client side, do not put any environment variable with sensitive information here
     */
    export enum ClientAvailableConfigurationValue {
        DEPLOYMENT_ENVIRONMENT = 'ENV',
        NODE_ENVIRONMENT = 'NODE_ENV',
        DATADOG_ENVIRONMENT = 'DD_ENV',
        DATADOG_VERSION = 'DD_VERSION',
    }

    export enum ServerSideConfigurationValue {
        AUTH_SERVICE_URL = 'AUTH0_SERVICE_URL',
        AUTH_CLIENT_SECRET = 'AUTH0_CLIENT_SECRET',
        AUTH_CLIENT_ID = 'AUTH0_CLIENT_ID',
        SIMON_DATA_API_KEY = 'SIMON_DATA_CLIENT_API_KEY',
        SERVICE_NAME = 'SERVICE_NAME',
        SERVICE_PORT = 'PORT',
        SPLIT_SERVER_SIDE_SECRET = 'SPLIT_SERVER_SIDE_SECRET',
        DD_API_KEY = 'DD_API_KEY',
        DD_APP_KEY = 'DD_APP_KEY',
        PAGE_FRAME_API_KEY = 'PAGE_FRAME_API_KEY',
        SERVICE_AUTH_CLIENT_ID = 'SERVICE_AUTH_CLIENT_ID',
        SERVICE_AUTH_CLIENT_SECRET = 'SERVICE_AUTH_CLIENT_SECRET',
    }
}
